<template>
  <button
    @click="handleClick"
    :class="[buttonSize, buttonType, { disabled: disabled }]"
    class=" text-base font-medium rounded border transition-all flex gap-2 items-center justify-center whitespace-nowrap"
    :disabled="disabled"
  >
    <component :is="icon" v-if="icon" />
    <span v-if="isLoading" class="flex items-center gap-2">
      <svg class="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
      </svg>
      {{ buttonText }}
    </span>
    <span v-else>
      {{ buttonText }}
    </span>
  </button>
</template>
<script>
export default {
  props: {
    buttonText: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'primary'
    },
    size: {
      type: String,
      default: 'regular'
    },
    icon: Function
  },
  data: () => ({
    buttonClass: {
      primary: 'bg-primary-400 text-white border-primary-400 hover:bg-primary-700 hover:border-primary-700',
      secondary: 'bg-transparent border-primary-400 text-primary-400 hover:border-primary-700 hover:text-primary-700',
      delete: 'bg-system-error text-white border-system-error',
      delete_outline: 'bg-transparent text-system-error border-system-error',
      amber: 'bg-amber-700 border-amber-700 text-white hover:opacity-90'
    },
    buttonCLassSize: {
      full: 'w-full py-2 px-6',
      regular: 'py-2 px-6',
      small: 'py-1 px-3',
      big: 'text-base py-3 px-6',
      big_full: 'w-full text-base py-3 px-6'
    }
  }),
  computed: {
    buttonType() {
      return this.buttonClass[this.type]
    },
    buttonSize() {
      return this.buttonCLassSize[this.size]
    }
  },
  methods: {
    handleClick() {
      this.$emit('action')
    }
  }
}
</script>
<style lang="scss" scoped>
.disabled {
  background-color: #d6d6d6;
  color: #fff;
  border-color: #d6d6d6;
  cursor: not-allowed;
}
</style>
